// A table's rules settings (issue 1125; docs/VTT/design/29-the-attack-chain.md §2.8): the DM's, per table, held on the
// table's own log like the group roll requests — never a scene's, never a player's. Decision C on #1059: damage waits
// for the DM's confirmation by default; the DM may set the table to apply it at once.
export const DAMAGE_MODES = ['confirm', 'apply'];
export const defaultRules = () => ({ damage: 'confirm' });
/** A system's slug as the site writes them (`scripts/mrcs-validate.js`). */
const SLUG_RE = /^[a-z0-9][a-z0-9.-]{0,63}$/;
/** A borrow from anywhere: exact shape or null. */
export function parseBorrow(v) {
    if (typeof v !== 'object' || v === null || Array.isArray(v))
        return null;
    const { system, name } = v;
    if (typeof system !== 'string' || !SLUG_RE.test(system))
        return null;
    if (typeof name !== 'string' || !name.trim() || name.length > 120)
        return null;
    return { system, name: name.trim() };
}
/** Rules from anywhere (the wire, a stored state): exact shape or null. */
export function parseRules(v) {
    if (typeof v !== 'object' || v === null || Array.isArray(v))
        return null;
    const { damage, borrow, override } = v;
    if (typeof damage !== 'string' || !DAMAGE_MODES.includes(damage))
        return null;
    if (override !== undefined && typeof override !== 'boolean')
        return null;
    const over = override ? { override: true } : {};
    if (borrow === undefined || borrow === null)
        return { damage: damage, ...over };
    const b = parseBorrow(borrow);
    return b ? { damage: damage, borrow: b, ...over } : null;
}
/** A stored state's rules, today's defaults for an older one. */
export const normaliseRules = (v) => parseRules(v) ?? defaultRules();
//# sourceMappingURL=tableRules.js.map